/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions
import { EditorInput } from "../../f";
import { Button } from "../../b";
import { NewWindowPortal } from "./common";
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'expandable-lexical-preview';

/**
 * This is the component description.
 */
const ExpandableLexicalPreview = ({
  id,
  className: userClassName,
  style,
  nodes,
  name,
  color,
  resize,
  pageTitle,
  onBlock,
  onOpen,
  header
  // ...otherProps
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleButtonClick = () => {
    setIsCollapsed(!isCollapsed);
  };
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      [name]: nodes
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, `y-${color}`, isCollapsed && 'collapsed'].filter(e => e).join(' '),
    style: style
  }, typeof header === 'string' ? /*#__PURE__*/React.createElement("p", {
    className: "title h2"
  }, header) : header, isCollapsed ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleButtonClick,
    color: "background-far",
    isCompact: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "ai-icon c-x x-paragraph"
  }, "C")), /*#__PURE__*/React.createElement(NewWindowPortal, {
    pageTitle: pageTitle,
    onBlock: () => {
      onBlock?.();
      setIsCollapsed(false);
    },
    onOpen: () => {
      onOpen?.();
      setIsCollapsed(true);
    }
  }, /*#__PURE__*/React.createElement(EditorInput, {
    name: name,
    resize: resize,
    disabled: true
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditorInput, {
    name: name,
    resize: resize,
    disabled: true,
    id: "the-bad-ass-input"
  }), /*#__PURE__*/React.createElement(Button, {
    id: id,
    className: "expand-button ai-icon",
    color: "background-far",
    isCompact: true,
    onClick: handleButtonClick
  }, "D"))));
};
ExpandableLexicalPreview.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * Color of the text
   */
  color: PropTypes.string,
  /**
   * The nodes to render in the form of a json string
   */
  nodes: PropTypes.string,
  /**
   * The resize property of the textarea
   */
  resize: PropTypes.string,
  /**
   * The header for the preview component.
   */
  header: PropTypes.node,
  /**
   * The page title for the expanded preview.
   */
  pageTitle: PropTypes.string,
  /**
   * The name used to acces the nodes
   */
  name: PropTypes.string.isRequired,
  /**
   * The function to run when a new window portal can be opened
   */
  onBlock: PropTypes.func.isRequired
};
ExpandableLexicalPreview.defaultProps = {
  color: 'paragraph',
  resize: 'vertical'
};
export default ExpandableLexicalPreview;